module.exports = __webpack_public_path__ + "img/pay_ali.576af3ff.png";